

























































import {Component, Vue, Watch} from 'vue-property-decorator';
import CompanyMixin from '@/mixins/CompanyMixin';
import BalanceGT from '@/charts/BalanceGT.vue';
import FinancialRatioItem from '@/views/FinancialRatioItem.vue';
import DynamicLineChart from '@/charts/DynamicLineChart.vue';
import DynamicColumnChart from '@/charts/DynamicColumnChart.vue';

@Component({components: {BalanceGT, DynamicColumnChart, DynamicLineChart, FinancialRatioItem}})
export default class CardBalanceNew extends CompanyMixin {
  selected: number = 4;
}
